import * as React from 'react'
import { IRiderObject, IStateMetadata } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import PersonalInfoForm from './PersonalInfoForm'

interface IPersonalInfoPaneProps {
  metadata: IStateMetadata
  rider: IRiderObject
  showMessage: (error: string, isError: boolean) => void
  updateRiderPersonalInfo: (rider: IRiderObject) => Promise<any>
}

class PersonalInfoPane extends React.Component<IPersonalInfoPaneProps, any> {
  constructor(props: any) {
    super(props)
    this.props.showMessage('', false)
  }

  public render() {
    if (!this.props.rider) {
      return null
    }
    return (
      <section>
        <div>
          <PersonalInfoForm
            showMessage={this.props.showMessage}
            rider={this.props.rider}
            updateRiderPersonalInfo={this.props.updateRiderPersonalInfo}
          />
        </div>
      </section>
    )
  }
}

export default PersonalInfoPane



// WEBPACK FOOTER //
// ./src/components/riders/editrider/personalinfo/PersonalInfoPane.tsx